module.exports = __webpack_public_path__ + "img/dateImg.1518d2a3.png";